const arabicNumberFmt = new Intl.NumberFormat('ar-SA', { maximumFractionDigits: 0 });

const VAT_RATE = 0.15;

export function withVat(amount: number): number {
  return Math.round(amount * (1 + VAT_RATE));
}

export function formatSAR(amount: number): string {
  return `${arabicNumberFmt.format(amount)} ر.س`;
}

export function formatSARFrom(amount: number): string {
  return `من ${arabicNumberFmt.format(amount)} ر.س`;
}

export function formatSARVatInc(amount: number): string {
  return formatSAR(withVat(amount));
}

export function formatNumber(n: number): string {
  return arabicNumberFmt.format(n);
}

export function formatPct(n: number): string {
  return `${arabicNumberFmt.format(n)}٪`;
}
